import { render } from "./UserActivity.vue?vue&type=template&id=28c6be2d&scoped=true"
import script from "./UserActivity.vue?vue&type=script&lang=js"
export * from "./UserActivity.vue?vue&type=script&lang=js"

import "./UserActivity.vue?vue&type=style&index=0&id=28c6be2d&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c6be2d"]])

export default __exports__